// ---------------------------------------------------------------
// Broker ↔ car linking with OWNER APPROVAL. Requests live on the device itself
// (Traccar attributes.brokerLinks), so they sync between the broker and the
// owner (both read the same device via the shared token). A broker entering a
// code creates a PENDING request; the owner must approve before the car shows
// in the broker's fleet.
// ---------------------------------------------------------------
import { updateDevice } from './traccar';

export const getBrokerLinks = (d) => ((d && d.attributes && d.attributes.brokerLinks) || []);

// 'pending' | 'approved' | 'declined' | null
export function brokerLinkStatus(d, brokerId) {
  const l = getBrokerLinks(d).find((x) => x.brokerId === brokerId);
  return l ? l.status : null;
}

// pending requests waiting on the owner
export const pendingLinks = (d) => getBrokerLinks(d).filter((x) => x.status === 'pending');
export const approvedLinks = (d) => getBrokerLinks(d).filter((x) => x.status === 'approved');

// broker asks to add this car → pending (replaces any prior entry for them)
export async function requestBrokerLink(device, broker) {
  const links = getBrokerLinks(device).filter((x) => x.brokerId !== broker.id);
  links.push({
    brokerId: broker.id,
    brokerName: broker.name || broker.email,
    brokerCompany: broker.company || '',
    brokerEmail: broker.email || '',
    at: new Date().toISOString(),
    status: 'pending',
  });
  const updated = { ...device, attributes: { ...(device.attributes || {}), brokerLinks: links } };
  await updateDevice(updated);
  return updated;
}

// owner toggles whether this broker gets LIVE tracking + alerts during a rental
export const brokerTrackingEnabled = (d, brokerId) => {
  const l = getBrokerLinks(d).find((x) => x.brokerId === brokerId);
  return l ? l.tracking !== false : false; // default ON for an approved broker
};
export async function setBrokerLinkTracking(device, brokerId, on) {
  const links = getBrokerLinks(device).map((x) => (x.brokerId === brokerId ? { ...x, tracking: !!on } : x));
  const updated = { ...device, attributes: { ...(device.attributes || {}), brokerLinks: links } };
  await updateDevice(updated);
  return updated;
}

// owner decision (or revoke): status = 'approved' | 'declined'
export async function setBrokerLinkStatus(device, brokerId, status) {
  const links = getBrokerLinks(device).map((x) => (x.brokerId === brokerId ? { ...x, status, decidedAt: new Date().toISOString() } : x));
  const updated = { ...device, attributes: { ...(device.attributes || {}), brokerLinks: links } };
  await updateDevice(updated);
  return updated;
}

// remove a link entirely (broker unlinks, or owner removes)
export async function removeBrokerLink(device, brokerId) {
  const links = getBrokerLinks(device).filter((x) => x.brokerId !== brokerId);
  const updated = { ...device, attributes: { ...(device.attributes || {}), brokerLinks: links } };
  await updateDevice(updated);
  return updated;
}
